import { useMemo } from 'react';
import { Box, Typography, IconButton, Grid } from '@mui/material';
import { styled, useMediaQuery, useTheme } from '@mui/system';
import { BR, AR, UY, CL, PE } from 'country-flag-icons/react/3x2';
import { IMAGE_BASE_PATH } from '../../config/paths';
import { Instagram } from "@mui/icons-material";
import { useNavigate } from 'react-router-dom';
import ButtonLink from '../buttons/ButtonLink';
import { useTranslation } from 'react-i18next';

const FlagIcon = styled(IconButton)(() => ({
    padding: 2,
    '& svg': {
        width: '24px',
        height: '20px',
        borderRadius: '6px',
    },
}));

const Footer = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();
    const { t } = useTranslation();

    const coreLogoHeight = '18px';
    const gwaHeight = '60px';
    const gkaHeight = '60px';

    const coreLogo = useMemo(() => (
        <Box
            component="img"
            src="/assets/CoreLogoRodape.avif"
            alt="Logo"
            sx={{
                height: coreLogoHeight,
            }}
            onClick={() => { navigate('/') }}
        />
    ), [navigate]);

    return (
        <Grid container direction="row">
            {/* Top Yellow Bar */}
            <Grid sx={{ backgroundColor: '#FFD700' }} size={12}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '42px'
                }}>
                    <Box
                        component="img"
                        src="/assets/CoreLogoRodape2.avif"
                        alt="Core Logo"
                        sx={{ height: '36px', cursor: 'pointer' }}
                        onClick={() => { navigate('/') }}
                    />
                    {!isMobile ? (
                        <>
                            <ButtonLink text={t('Appbar.loja')} href="https://core-esportes-aquaticos.lojaintegrada.com.br/" external fontColor='black' fontHoverColor='white' />
                            <ButtonLink text={t('KITE')} href="https://core-esportes-aquaticos.lojaintegrada.com.br/kites" external fontColor='black' fontHoverColor='white' />
                            <ButtonLink text={t('WING')} href="https://core-esportes-aquaticos.lojaintegrada.com.br/wings" external fontColor='black' fontHoverColor='white' />
                            <ButtonLink text={t('FOIL')} href="https://core-esportes-aquaticos.lojaintegrada.com.br/foil" external fontColor='black' fontHoverColor='white' />
                            <ButtonLink text={t('Footer.acessoriosButton')} href="https://core-esportes-aquaticos.lojaintegrada.com.br/acessorios" external fontColor='black' fontHoverColor='white' />
                            <ButtonLink text={t('Footer.pecasButton')} href="https://core-esportes-aquaticos.lojaintegrada.com.br/pecas" external fontColor='black' fontHoverColor='white' />
                        </>
                    ) : (
                        <ButtonLink text={t('Appbar.loja')} href="https://core-esportes-aquaticos.lojaintegrada.com.br/" external fontColor='black' />
                    )}
                </Box>
            </Grid>

            {/* Instagram Section */}
            <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }} order={{ xs: 1, sm: 1, md: 2 }} sx={{ backgroundColor: '#000', textAlign: "center" }}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    pt: isTablet || isMobile ? 1.5 : undefined,
                }}>
                    <IconButton sx={{ color: '#fff' }} onClick={() => window.open('https://www.instagram.com/corekites.latam/', '_blank')}>
                        <Instagram sx={{ fontSize: 24 }} />
                        <Typography fontSize={16} color='white'
                            sx={{ fontFamily: 'PFDinTextCompPro-Medium, Arial, sans-serif' }}>
                            COREKITES.LATAM
                        </Typography>
                    </IconButton>
                </Box>
            </Grid>

            {/* Flags Section */}
            <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }} order={{ xs: 2, sm: 2, md: 1 }} sx={{ backgroundColor: '#000', textAlign: "center" }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 0.3, // espaço entre flags e logo
                        pt: 1,
                        pb: {xs: 3, md: 0}
                    }}
                >
                    <Box>
                        <FlagIcon aria-label="Brasil"><BR /></FlagIcon>
                        <FlagIcon aria-label="Argentina"><AR /></FlagIcon>
                        <FlagIcon aria-label="Uruguai"><UY /></FlagIcon>
                        <FlagIcon aria-label="Chile"><CL /></FlagIcon>
                        <FlagIcon aria-label="Peru"><PE /></FlagIcon>
                    </Box>

                    {coreLogo}
                </Box>
            </Grid>

            {/* Logos Section */}
            <Grid
                padding={1}
                size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                order={3}
                sx={{ backgroundColor: '#000', textAlign: "center", display: isMobile || isTablet ? "none" : undefined }}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                }}>
                    <Box component="img" src={`${IMAGE_BASE_PATH}core/GKA.avif`} alt="Logo" sx={{ height: gkaHeight, marginRight: 3 }} onClick={() => window.open('https://www.globalwingsportsassociation.org/', '_blank')} />
                    <Box component="img" src={`${IMAGE_BASE_PATH}core/KJK.avif`} alt="Logo" sx={{ height: coreLogoHeight, marginRight: 3 }} onClick={() => window.open('https://kjksports.com/', '_blank')} />
                    <Box component="img" src={`${IMAGE_BASE_PATH}core/GWA.avif`} alt="Logo" sx={{ height: gwaHeight }} onClick={() => window.open('https://www.globalwingsportsassociation.org/', '_blank')} />
                </Box>
            </Grid>
        </Grid>
    );
};

export default Footer;